<template>
  <b-form-input
    @input="onInput"
    @keyup="onKeyup"
    @keypress.native="onKeypress"
    @paste.prevent
    :value="value"
    maxlength="5"
    :placeholder="placeholder"
    :class="className"
    :disabled="disabled"
    inputmode="numeric"
    pattern="[0-9]*"
    autocomplete="off"
  />
</template>

<script>
export default {
  props: ["value", "placeholder", "className", "disabled"],
  methods: {
    onKeyup(e) {
      const character = String.fromCharCode(e.keyCode);

      if (/^\d*$/.test(String.fromCharCode(e.keyCode))) this.$emit("keyup", e);
      else if(character == ".") this.$emit("keyup", e)
    },
    onKeypress(e) {
      const character = String.fromCharCode(e.keyCode);

      if (/\D/g.test(character)) {
        if(character != ".")
          e.preventDefault();
      }

      const newValue = e.target.value + character;
      if(character == "." && e.target.value.includes(".")) e.preventDefault() ;
      if(character != ".") {
        if (!(/^\d*\.?\d{1,2}$/.test(newValue))) e.preventDefault();
      }

      if (
        parseInt(newValue) > 100 ||
        (e.target.selectionStart === 0 && character === "0")
      )
        e.preventDefault();
    },
    onInput(value) {
      this.$emit("input", value);
    },
  },
};
</script>

